import { useEffect, useState } from 'react';
import { getBasicInfo } from 'api/newUniprofile';
import { IBasicInfoStep, INewUniprofileResume } from 'types/newUniprofile';
import uniprofileResumeStore from 'store/UniprofileResume';
import { getUrlParam } from 'utils/common';

export const useBasicInfo = (isAva?: boolean, scheduleToken?: string): [IBasicInfoStep, boolean, () => void] => {
    const [loading, setLoading] = useState(false);
    const [serviceData, setServiceData] = useState<IBasicInfoStep>({} as IBasicInfoStep);
    const [getResumeInfo] = uniprofileResumeStore.useStore();
    const isAvaParam = isAva || getUrlParam('isAva') === 'true';

    const getResumeData = () => {
        const resumeData = getResumeInfo('data') as INewUniprofileResume;
        if (resumeData?.basicInfo) {
            setServiceData(resumeData.basicInfo);
        }
    };
    const fetchData = async () => {
        try {
            setLoading(true);
            const result = await getBasicInfo(scheduleToken);
            if (!result.error) {
                const data: IBasicInfoStep = result?.data?.data || {};
                setServiceData(data);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (isAvaParam) {
            getResumeData();
        } else {
            fetchData();
        }
    }, []);

    useEffect(() => {
        if (isAvaParam) {
            getResumeData();
        }
    }, [getResumeInfo('data')]);

    return [serviceData, loading, fetchData];
};
